import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./campaign_configuration.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { Dialog } from "@progress/kendo-react-dialogs";
import BackIcon from "../../../assets/communication/Back.svg";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST, REWARDS_INVENTORY_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import Docfile from "../../../assets/rewards/file.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { TextBox } from "@progress/kendo-react-inputs";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
import { createAndUpdateCampaignCategory, createAndUpdateCampaignRewardProvider, fetchCampaignCategoryDetail, fetchCampaignCategoryList } from "../../../store/campaign_configuration";
const { CAMPAIGN_IMAGE_UPLOAD_ENDPOINT } = config.api_endpoint;

export const CreateUpdateCampaignCategory = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const DocRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);

  const [showUploadOverrideWarning, setShowUploadOverrideWarning] = useState(false);
  const [tempDoc, setTempDoc] = useState("");
  const [doc, setDoc] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");


  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const AddPermission = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  );

  const [file, setFile] = useState("");

  const [loading, setLoading] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);


  const [error, setError] = useState({
    name: "",
    doc: "",
  });


  const [editData, setEditData] = useState({
    name: "",
    template_s3_key: "",
    template_upload_url: ""
  });

  const getData = async () => {
    setLoading(true);
    if (id) {
      dispatch(fetchCampaignCategoryDetail(id)).then((res) => {


        let payload = res.payload;


        setEditData({
          ...editData,
          template_s3_key: payload.template_s3_key,
          template_upload_url: payload.template_upload_url
        });

        setLoading(false);

      });
    } else {
      setLoading(false);

    }
  };


  const checkMandatoryFields = () => {

    const { name } = editData;



    if (!name
    ) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }



  };



  const handleSubmit = () => {
    if (checkMandatoryFields()) return;


    setLoading(true);

    let updatedData = { ...editData };

    if (id) {  // Ensures id is neither null nor empty
      updatedData.id = id;
    }


    dispatch(createAndUpdateCampaignCategory({ data: updatedData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        const saved_id = payload.data?.id || id;
        getData();

        setLoading(false);

        navigate(ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST);

      } else {
        setLoading(false);



      }
    });



  };



  const mimeToExtension = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
  };


  const docUpload = () => {
    DocRef.current.click();
  };


  const onUploadDoc = async (e) => {
    setImageLoading(true);
    

    const token = await getCurrentLoggedInSessionTokenWithPromise();
    const extension_ = e.type
      ? mimeToExtension[e.type] || e.type.split("/")[1]
      : e.name.split(".").pop();
    api
      .post(
        `${CAMPAIGN_IMAGE_UPLOAD_ENDPOINT}`,
        JSON.stringify({
          extension: extension_,
        }),
        token
      )
      .then((res) => {
        setDoc(e);
        setImageLoading(false);
      });
  };



  const DocHandler = () => {


    let name =
      id
        ? doc.name
        : doc !== "" && doc.name;
    return (
      <div className="campaigns_create_file_main_box">
        <div className="campaigns_create_file_child_box">
          <div className="campaigns_document_container">
            <Icon className="campaigns_document_icon">
              <img alt="" src={Docfile} />
            </Icon>
            <div className="campaigns_document_text">{name}</div>

          </div>
        </div>
        <div>
          <span
            class="k-icon k-font-icon k-i-delete campaigns_create_file_child_box_delete_icon"
            onClick={() => {
              setDoc("");
            }}
          />
        </div>
      </div>
    );

  };






  return (
    <>
      {AddPermission ? (
        <div style={{ height: "calc(100% - 75px)" }}>



          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {showError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowError(false)}
            >
              <p>{errorMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowError(false)}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}


          {imageLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 76px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          {showUploadOverrideWarning && (
            <Dialog
              className="alert-form"
              title={"Confirmation"}
              width={500}
              // height={280}
              onClose={() => setShowInvalidNomineeDialog(false)}
            >
              <p className="campaigns-dialog-text-align"><b>Confirmation for Importing</b></p>
              <p className="campaigns-dialog-text-align">Uploading this file will override all existing data with the new data from the uploaded file. Do you want to proceed?</p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTempDoc("");
                    setShowUploadOverrideWarning(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    onUploadDoc(tempDoc);
                    setShowUploadOverrideWarning(false);

                  }}
                >
                  Override
                </div>
              </div>
            </Dialog>
          )}

          {(loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="campaign-configuration-body">
            <div className="campaign-configuration-add-header" >
              <div className="back-title-group" onClick={(e) => props.backBtncallback(e)}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="campaign-configuration-container">
            <div className="main-campaign-configuration">
              <div className="campaign-configuration-scroll-box">
                <div>
                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration-header">
                      Campaign Category
                    </div>

                    <div className="campaign-configuration_create_item_main_box_title">
                      Category Name
                    </div>
                    <div>
                      <TextBox
                        className="campaign-configuration_create_item_main_box_field"
                        value={editData.name}
                        disabled={!AddPermission}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            name: e.target.value,
                          })
                        }
                      />
                      {error.name !== "" && (
                        <div className="campaign-configuration_create_error_text">
                          {error.name}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="campaign-configuration_create_item_main_box">
                    <div className="campaign-configuration_create_upload_main_box">
                      <div className="campaign-configuration_create_item_main_box_title">
                        Upload Excell Template
                      </div>
                    </div>
                    {!doc && editData.template_s3_key === "" && (<div className="campaign-configuration_nodata_view">
                      <div className="campaign-configuration_nodata_title"> No File</div>
                      {AddPermission && (
                        <div className="campaign-configuration_create_upload_button_box">
                          <div onClick={docUpload}>
                            <div>+ Upload Excel</div>
                            <input
                              accept={[
                                // "image/jpeg",
                                // "image/png",
                                // "image/jpg",
                                "application/vnd.ms-excel",
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              ]}
                              ref={DocRef}
                              type="file"
                              hidden
                              onClick={(e) => (e.target.value = "")}
                              onChange={(e) => {

                                onUploadDoc(e.target.files[0])


                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>)}
                    {doc && <DocHandler />}

                  </div>





                </div>



              </div>

            </div>

            <div className="campaign-configuration-footer">
              <div className="footer-left-btn-groups"></div>

              <div className="campaign-configuration-footer-right">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST);
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>



            </div>
          </div>


        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
